import { render, staticRenderFns } from "./ServiceQuestionIndex.vue?vue&type=template&id=293d19b4"
import script from "./ServiceQuestionIndex.vue?vue&type=script&lang=js"
export * from "./ServiceQuestionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports